import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';
import { showHelperText } from '../../commercial/Switch/utils';
import { getRelationShip } from '../../portfolios/utils';

export default function EmailRelationship({ emailFormik }: any) {
    return (
        <div style={{ marginTop: 20, maxWidth: 350, width: '100%' }}>
            <FormControl variant="outlined">
                <InputLabel htmlFor="emailRelationship" variant="outlined">
                    {' '}
                    Email Relationship
                </InputLabel>
                <Select
                    name="emailRelationship"
                    value={emailFormik.values.emailRelationship}
                    onChange={emailFormik.handleChange}
                >
                    {Object.keys(getRelationShip).map((key: any) => (
                        <MenuItem value={key}>{getRelationShip[key]}</MenuItem>
                    ))}
                </Select>
                <FormHelperText style={{ color: 'red', padding: 0, fontSize: 12 }}>
                    {showHelperText(emailFormik, 'emailRelationship')}
                </FormHelperText>
            </FormControl>
        </div>
    );
}
